import { CachedRequest } from './base/cachedRequest'
import { endpoint } from './endpoints/def'
import { ILoginParameters } from 'services/auth/auth.slice'

export const instance = new CachedRequest(1000 * 3)

export async function apiLogin(args: ILoginParameters) {
  return instance.post(endpoint.login, args)
}
